import { render, staticRenderFns } from "./ManageSage.vue?vue&type=template&id=972fd80e&"
import script from "./ManageSage.vue?vue&type=script&lang=js&"
export * from "./ManageSage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports